import request from '../request';

export default {
  // 登录
  login(data) {
    return request.post('/admin/login', data);
  },

  // 管理员信息
  info(data) {
    return request.get('/admin/info', data);
  },

  //获取菜单-平台
  getMenus(data) {
    return request.get('/menu', data);
  },

  /**
   *  获取权限列表
   *  @params type 1菜单 2节点
   * */
  getPermission(data) {
    return request.get('/permission/lists', data);
  },

  /**
   *  新增权限（菜单）
   * */
  addPermission(data) {
    return request.post('/permission/add', data);
  },

  /**
   *  修改权限（菜单）
   *  id
   * */
  editPermission(data) {
    return request.post('/permission/edit', data);
  },

  //删除权限
  deletePermission(data) {
    return request.post('/permission/delete', data);
  },

  //清除缓存
  clearCache(data) {
    return request.get('/clearCache', data);
  },

  //角色列表
  getRoleList(data) {
    return request.get('/role/lists', data);
  },

  //角色删除
  deleteRole(data) {
    return request.post('/role/delete', data);
  },

  //角色添加
  addRole(data) {
    return request.post('/role/add', data);
  },

  //角色修改
  editRole(data) {
    return request.post('/role/edit', data);
  },

  //平台账号-新增
  addAdmin(data) {
    return request.post('/admin/add', data);
  },

  //平台账号-修改
  editAdmin(data) {
    return request.post('/admin/edit', data);
  },

  //平台账号-列表
  getAdmin(data) {
    return request.get('/admin/lists', data);
  },

  //平台账号-删除
  deleteAdmin(data) {
    return request.post('/admin/delete', data);
  },

  //平台-SaaS账号-新增
  addAdminSaaS(data) {
    return request.post('/adminUser/add', data);
  },

  //平台-SaaS账号-修改
  editAdminSaaS(data) {
    return request.post('/adminUser/edit', data);
  },

  //平台-SaaS账号-列表
  getAdminSaaS(data) {
    return request.get('/adminUser/lists', data);
  },

  //平台-SaaS账号-删除
  deleteAdminSaaS(data) {
    return request.post('/adminUser/delete', data);
  },

  //平台账号-角色数据源
  roleList(data) {
    return request.get('/adminUser/roleList', data);
  },

  //给角色分配节点权限
  permissionAssign(data) {
    return request.post('/permission/assign', data);
  },

  //修改密码
  updatePwd(data) {
    return request.post('/Admin/updatePwd', data);
  },

  //用户权限
  getClientList(data) {
    return request.get('/adminUser/getClientList', data);
  },

  getUserAreaInfo(data) {
    return request.get('/adminUser/getUserAreaInfo', data);
  },

  setAdminType(data) {
    return request.post('/adminUser/setAdminType', data);
  },
};
